import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { DeviceType } from './types.ts'

interface EditProps {
  device: DeviceType
}

export default function Edit({ device }: EditProps) {
  return (
    <>
      <Head title="Editing device" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing device</h1>

        <Form
          device={device}
          action={`/admin/devices/${device.id}`}
          method="patch"
          submitText="Mettre à jour le terminal"
        />

        <Link
          href={`/admin/devices/${device.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Voir ce terminal
        </Link>
        <Link
          href="/admin/devices"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux terminaux
        </Link>
      </div>
    </>
  )
}
